import React, { useCallback, useState, useEffect } from 'react';
import { FormGroup, Intent } from '@blueprintjs/core';

import { MoneyInputGroup } from '@/components/Forms/MoneyInputGroup';
import { CellType } from '@/constants';
import { CellRendererProps } from './types';

const PercentFieldCell = ({
  cell: { value: initialValue },
  row: { index },
  column: { id },
  payload: { errors, updateData },
}: CellRendererProps) => {
  const [value, setValue] = useState(initialValue);

  const handleBlurChange = (newValue: string | undefined) => {
    const parsedValue =
      newValue === '' || newValue === undefined ? '' : parseInt(newValue, 10);
    updateData(index, id, parsedValue);
  };

  const handleChange = useCallback(
    (value: any) => {
      setValue(value);
    },
    [setValue],
  );

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const error = errors?.[index]?.[id];

  return (
    <FormGroup intent={error ? Intent.DANGER : undefined}>
      <MoneyInputGroup
        prefix={'%'}
        value={value}
        onChange={handleChange}
        onBlurValue={handleBlurChange}
      />
    </FormGroup>
  );
};

PercentFieldCell.cellType = CellType.Field;

export default PercentFieldCell;
